import { RequestsWorkspace } from '@/components/requests/requests-workspace'

export function CommitteeRequests() {
  return <RequestsWorkspace />
}
